var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalyticsbusinessinsights6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1600 326",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-27,.cls-32,.cls-33,.cls-34,.cls-6{fill:none;}.cls-2{isolation:isolate;}.cls-3{fill:#d8c4df;}.cls-4{font-size:70px;font-family:CenturyGothic-Bold, Century Gothic;font-weight:700;}.cls-29,.cls-4{fill:#2f2143;}.cls-5{fill:#e7b7b7;}.cls-6{stroke:#565349;stroke-width:0.88px;}.cls-27,.cls-32,.cls-33,.cls-34,.cls-6{stroke-miterlimit:10;}.cls-7{fill:#1f3242;}.cls-8{fill:#f9f9fc;}.cls-9{fill:#fdc435;}.cls-10{fill:#337abb;}.cls-11{fill:#966666;}.cls-12{fill:#e3a2a2;}.cls-13{mix-blend-mode:multiply;}.cls-14{clip-path:url(#clip-path);}.cls-15{fill:#9173b4;}.cls-16{clip-path:url(#clip-path-2);}.cls-17{fill:#9cbfe5;}.cls-18{opacity:0.6;}.cls-19{clip-path:url(#clip-path-3);}.cls-20{clip-path:url(#clip-path-4);}.cls-21{clip-path:url(#clip-path-5);}.cls-22{clip-path:url(#clip-path-6);}.cls-23{clip-path:url(#clip-path-7);}.cls-24{clip-path:url(#clip-path-8);}.cls-25{clip-path:url(#clip-path-9);}.cls-26{clip-path:url(#clip-path-10);}.cls-27,.cls-33,.cls-34{stroke:#2f2143;}.cls-27{stroke-width:1.37px;}.cls-28{fill:#ffc537;}.cls-30{fill:#ffc436;}.cls-31{fill:#9a499c;}.cls-32{stroke:#9a499c;}.cls-32,.cls-34{stroke-width:2px;}.cls-33{stroke-width:1.41px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 133.59,
    y: 118.81,
    width: 54.17,
    height: 44.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 135.42,
    y: 139.64,
    width: 52.35,
    height: 23.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 115.73,
    y: 92.87,
    width: 102.33,
    height: 78.78
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 175.14,
    y: 61.82,
    width: 35.27,
    height: 22.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 301.16,
    y: 110.95,
    width: 16.72,
    height: 15.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 299.29,
    y: 132.1,
    width: 58.37,
    height: 19.21
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 299.29,
    y: 132.1,
    width: 45.85,
    height: 19.21
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 291.62,
    y: 103.9,
    width: 78.84,
    height: 51.88
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 257.39,
    y: 27.51,
    width: 109.85,
    height: 49.96
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 128.42,
    y: 32.31,
    width: 20.86,
    height: 20.18
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ANALYTICS &amp;amp; BUSINESS INSIGHTS 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 1600,
    height: 326
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(588.58 159.09)"
  }, "ANALYTICS &amp;", /*#__PURE__*/React.createElement("tspan", {
    x: -92.4,
    y: 79
  }, "BUSINESS INSIGHTS")), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M343.74,152.51c.26-1.13,1.82-4.18-2.09-7.76-1.95-1.79-4.57-7.95-5-8.67-1.39-2.31-1.68-6.38-2-7.28-.15-.39,1.6-1.8,3.62-.06.8.69,1.41,1.9,2.06,4.21.34,1.21,2.25,4,3.19,3.88,1.2-.17,1.91-.81,2-2.44.35-4.17-4.88-17.84-4.34-19a2,2,0,0,1,3.74.32c.61,1.44,2.34,6.82,3.31,6.67.59-.09.41-5.28.19-10.08a1.85,1.85,0,0,1,3.52-1.06c.58,3,1,5.66,1.46,6s.62-2.14.81-2.77a1.78,1.78,0,0,1,3.43.13c.1.53.85,8.94,1.85,9,.67,0,.61-2.69.7-3,.62-2,3.38-1.64,3.33.8-.05,2.13-.17,11.34-.34,13.63-.21,3-.28,8.88-3.18,21.9Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M360,156.87c-3,14-5.3,66.11-14.8,69.68-9.74,3.66-31.7-11.29-31.7-11.29L324,189.71l8.24,6.38c2.84-15.1,11.54-43.58,11.54-43.58Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M332.2,196.09a48.1,48.1,0,0,0,0,14.84",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M348.36,136c5.44,1.76,7.64,7.63,7.64,7.63",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M348.26,122.33c.71,2.25,1.5,6.44,1.5,6.44",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M353.43,117.17c.72,5.16,1,11.6,1,11.6",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M359.52,123.51c.07,1.48,0,5.94,0,5.94",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M178.26,152.51c-.27-1.13-1.83-4.18,2.08-7.76,2-1.79,4.57-7.95,5-8.67,1.38-2.31,1.68-6.38,2-7.28.14-.39-1.6-1.8-3.63-.06-.8.69-1.4,1.9-2,4.21-.35,1.21-2.25,4-3.19,3.88-1.2-.17-1.91-.81-2.05-2.44-.35-4.17,4.89-17.84,4.35-19a2,2,0,0,0-3.74.32c-.61,1.44-2.34,6.82-3.32,6.67-.58-.09-.4-5.28-.18-10.08a1.85,1.85,0,0,0-3.52-1.06c-.58,3-1,5.66-1.46,6s-.62-2.14-.81-2.77a1.78,1.78,0,0,0-3.43.13c-.1.53-.85,8.94-1.85,9-.67,0-.61-2.69-.7-3-.63-2-3.38-1.64-3.33.8,0,2.13.17,11.34.33,13.63a119,119,0,0,0,3.19,21.9Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M162,156.87c3,14,5.29,66.11,14.8,69.68,9.74,3.66,31.7-11.29,31.7-11.29L198,189.71l-8.24,6.38c-2.84-15.1-11.54-43.58-11.54-43.58Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M189.8,196.09a48.1,48.1,0,0,1,0,14.84",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M173.63,136c-5.44,1.76-7.63,7.63-7.63,7.63",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M173.73,122.33c-.7,2.25-1.49,6.44-1.49,6.44",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M168.57,117.17c-.72,5.16-1,11.6-1,11.6",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M162.48,123.51c-.08,1.48,0,5.94,0,5.94",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M257.55,326c1.87-9,3.45-15.64,3.45-15.64L265,326h40.52l-4.24-51H220.76s-2.82,26.71-4.81,51",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M288.51,164.13H233.66V276.76C251.54,282,288.51,278,288.51,278Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M275.74,164.13c.68,8-4,15.38-14.74,15.38-14.88,0-14.88-15.38-14.88-15.38Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M255.52,183.64c4,14.19-1.74,100.84-1.74,100.84-22.41.95-35.5-5.06-35.5-5.06L223.66,208l-18.74,12.64c-7.41-2.93-12.09-28.77-12.09-28.77s30.67-27.78,40.83-27.78h15.5c-12.56,8.89,6.36,19.51,6.36,19.51",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M266.65,183.64c-4,14.19,1.74,100.84,1.74,100.84,22.41.95,35.5-5.06,35.5-5.06L298.51,208l18.74,12.64c7.41-2.93,12.09-28.77,12.09-28.77s-30.67-27.78-40.83-27.78H273c12.56,8.89-6.36,19.51-6.36,19.51",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M249.16,164.13l.56-5.68s-5.4,2.34-7.81,5.68,0,24.66,0,24.66,4.57-6.72,6.06-6.89,7.55,1.74,7.55,1.74-11.06-13.06-6.36-19.51",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M273,164.13l-.41-5.68s5.25,2.34,7.66,5.68,0,24.66,0,24.66-4.57-6.72-6.06-6.89-7.55,1.74-7.55,1.74,11.06-13.06,6.36-19.51",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M298.51,208c-1.22-4.53-2.44-18.22-2.44-18.22",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M223.66,208c.62-6.07,2.11-19.89,2.11-19.89",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M234.53,123.91c2.15,7.21,4.81,9.32,10.25,11.55l25.69,10.76c7.58-8.2,9.1-12,9.1-23.14,4.83-9.71-1.52-25.27-11.53-22.29-8.73-13.94-47.83,4.8-33.51,23.12",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M248.82,167.56c.78,2.05,5.58,7.46,11.5,7.46,8.61,0,12.86-7.14,12.86-10.06L270,129.38l-18.34,3.7c.27,2.69-2.07,26.56-2.87,34.48",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M250.92,145.4,265.77,144s-.71,11.9-15.95,13.44Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M239,116.89c-3.55,5.65-1.15,8.71-1.15,14.34,0,6-2.31,14.59,2.52,19.06,5,4.62,16.61,4.84,24.55-5.17s6.19-27-2.52-31.33c-7.45-3.72-18.48-4.72-23.4,3.1",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M235.51,123.91c6.42.89,10.33-7.31,17.25-9a8.78,8.78,0,0,0,7.59,7.85c6.32,3,5.29,11.1,7.47,11.1,1.26,0,1.16-5.41,2.25-7.16,4.52-7.19,1.84-14.66-6-18.13s-17.55-4.57-23,0-5.57,15.29-5.57,15.29",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M243.9,139.93c-2.76,0-3.31-.56-3.74-1.28-.27-.46,0-1.34.56-3.29a38.53,38.53,0,0,0,1.09-4.26.32.32,0,0,1,.37-.26.32.32,0,0,1,.27.37,42.31,42.31,0,0,1-1.11,4.34,11.32,11.32,0,0,0-.65,2.72c.29.5.6,1,3.21,1a.33.33,0,0,1,0,.65",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M262,132.75a3.08,3.08,0,1,1-4.32-1.62,3.27,3.27,0,0,1,4.32,1.62",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M249.3,128.46c0,1.17-.56,2.12-1.25,2.12s-1.25-1-1.25-2.12.56-2.12,1.25-2.12,1.25,1,1.25,2.12",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M245.84,124.58c.26.89,2.48-.71,3.79-.58,2.22.22,2.31,1.34,3.12,1.13.11-1-1.31-2.32-3.24-2.45a3.49,3.49,0,0,0-3.67,1.9",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M240,129.38c0,1-.46,1.76-1,1.76s-1-.79-1-1.76.47-1.76,1-1.76,1,.79,1,1.76",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M240.51,125.85c0,.7-1.87,0-2.69.34-1.36.59-1.39,1.68-1.77,1.51a2.17,2.17,0,0,1,1.46-2.47,2.66,2.66,0,0,1,3,.62",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M250.76,140.61a15.63,15.63,0,0,1-6.18,3.36,8,8,0,0,0,4.72,1.18c2.23-.39,1.46-4.54,1.46-4.54",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "148.03 163.01 137.46 163.01 133.59 118.81 144.16 118.81 148.03 163.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "168.86 163.01 158.29 163.01 155.77 134.19 166.34 134.19 168.86 163.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "187.77 163.01 177.2 163.01 175.85 147.64 186.42 147.64 187.77 163.01"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "148.03 163.01 137.46 163.01 135.42 139.64 145.99 139.64 148.03 163.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "168.86 163.01 158.29 163.01 157.62 155.32 168.19 155.32 168.86 163.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "187.77 163.01 177.2 163.01 176.2 151.63 186.77 151.63 187.77 163.01"
  }))), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "123.11 114.97 127.31 163.01 204.17 163.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M209.17,132.26a4.28,4.28,0,0,0-4.18-3.84,3.47,3.47,0,0,0-3.51,3.84,4.28,4.28,0,0,0,4.18,3.85,3.46,3.46,0,0,0,3.51-3.85",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M210.32,145.4a4.28,4.28,0,0,0-4.18-3.84,3.47,3.47,0,0,0-3.51,3.84,4.28,4.28,0,0,0,4.18,3.84,3.47,3.47,0,0,0,3.51-3.84",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M208,119.13a3.46,3.46,0,0,1-3.51,3.84,4.28,4.28,0,0,1-4.18-3.84,3.47,3.47,0,0,1,3.51-3.84,4.28,4.28,0,0,1,4.18,3.84",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M214.55,171.66h-89a3.51,3.51,0,0,1-3.5-3.2l-6.27-71.77a3.51,3.51,0,0,1,3.49-3.82h89a3.51,3.51,0,0,1,3.5,3.21l6.28,71.76a3.52,3.52,0,0,1-3.5,3.82",
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "205.06 67.12 193.53 67.12 193.45 66.16 204.97 66.16 205.06 67.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "198.51 69.15 193.71 69.15 193.62 68.19 198.43 68.19 198.51 69.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "205.41 71.18 193.88 71.18 193.8 70.22 205.33 70.22 205.41 71.18"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M180,84.19H206.9a3.51,3.51,0,0,0,3.5-3.81L209.05,65a3.5,3.5,0,0,0-3.49-3.2H178.65a3.51,3.51,0,0,0-3.5,3.81L176.5,81a3.5,3.5,0,0,0,3.49,3.2",
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M189.71,77.56c.22,2.5-1.87,3.15-4.53,3.15s-4.86-.65-5.08-3.15A4.22,4.22,0,0,1,184.51,73a5.21,5.21,0,0,1,5.2,4.54",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M186.79,68.19a3.21,3.21,0,0,0-3.13-2.89A2.6,2.6,0,0,0,181,68.19a3.21,3.21,0,0,0,3.13,2.88,2.6,2.6,0,0,0,2.63-2.88",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "316.53 126.32 301.16 126.32 302.5 110.95 317.87 110.95 316.53 126.32"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "357.32 135.94 300.63 135.94 300.97 132.1 357.66 132.1 357.32 135.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "343.2 143.63 299.96 143.63 300.3 139.79 343.53 139.79 343.2 143.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "349.25 151.32 299.29 151.32 299.63 147.47 349.59 147.47 349.25 151.32"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "344.8 135.94 300.63 135.94 300.97 132.1 345.14 132.1 344.8 135.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "333.65 143.63 299.96 143.63 300.3 139.79 333.99 139.79 333.65 143.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "338.22 151.32 299.29 151.32 299.63 147.47 338.56 147.47 338.22 151.32"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "354.64 112.87 329.66 112.87 329.83 110.95 354.81 110.95 354.64 112.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "349.4 117.85 329.23 117.85 329.4 115.93 349.57 115.93 349.4 117.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "344.17 122.82 328.79 122.82 328.96 120.9 344.33 120.9 344.17 122.82"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M363,155.78h-67.9a3.5,3.5,0,0,1-3.49-3.81l3.92-44.87a3.51,3.51,0,0,1,3.5-3.2H367a3.52,3.52,0,0,1,3.5,3.82l-3.93,44.86a3.5,3.5,0,0,1-3.49,3.2",
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M263.27,71.71h75c.71-13.51-.29-24.22-8.07-24.22-8.93,0-3.56,11.8-14.57,11.8-11.41,0-2.08-20.7-12.86-20.7-11.88,0-1.61,21.82-15.1,21.82-9.57,0-4.51-12.92-13.27-12.92-7.38,0-10.53,12.92-10.53,12.92Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M263.27,71.71h75c.71-13.51-.29-24.22-8.07-24.22-8.93,0-3.56,11.8-14.57,11.8-11.41,0-2.08-20.7-12.86-20.7-11.88,0-1.61,21.82-15.1,21.82-9.57,0-4.51-12.92-13.27-12.92-7.38,0-10.53,12.92-10.53,12.92Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M276.31,47.49a1.8,1.8,0,0,0-1.82-1.92,2,2,0,0,0-2,1.92,1.8,1.8,0,0,0,1.82,1.93,2,2,0,0,0,2-1.93",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M289.58,60.41a1.8,1.8,0,0,0-1.82-1.92,2,2,0,0,0-2,1.92,1.81,1.81,0,0,0,1.82,1.92,2,2,0,0,0,2-1.92",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M304.68,38.59a1.81,1.81,0,0,0-1.82-1.92,2.06,2.06,0,0,0-2,1.92,1.81,1.81,0,0,0,1.83,1.92,2,2,0,0,0,2-1.92",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M317.54,59.29a1.8,1.8,0,0,0-1.82-1.92,2,2,0,0,0-2,1.92,1.8,1.8,0,0,0,1.82,1.92,2,2,0,0,0,2-1.92",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M332.11,47.49a1.8,1.8,0,0,0-1.82-1.92,2,2,0,0,0-2,1.92,1.8,1.8,0,0,0,1.82,1.93,2,2,0,0,0,2-1.93",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "359.35 71.7 263.27 71.7 265.29 33.27"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "261.71 36.67 265.29 33.27 268.5 36.67"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "356.13 68.31 359.35 71.71 355.77 75.1"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M361.48,77.47H260.9a3.5,3.5,0,0,1-3.5-3.69l2.25-42.95a3.51,3.51,0,0,1,3.5-3.32H363.73a3.5,3.5,0,0,1,3.5,3.69l-2.25,43a3.5,3.5,0,0,1-3.5,3.32",
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M360.06,34.79a2.56,2.56,0,0,1-2.52,2.41,2.26,2.26,0,0,1-2.28-2.41,2.56,2.56,0,0,1,2.53-2.4,2.26,2.26,0,0,1,2.27,2.4",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M359.67,42.34a2.56,2.56,0,0,1-2.53,2.41,2.26,2.26,0,0,1-2.28-2.41,2.57,2.57,0,0,1,2.53-2.4,2.26,2.26,0,0,1,2.28,2.4",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M359.27,49.9a2.56,2.56,0,0,1-2.53,2.4,2.26,2.26,0,0,1-2.27-2.4A2.56,2.56,0,0,1,357,47.49a2.26,2.26,0,0,1,2.27,2.41",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M145.76,52.49H132.61a3.51,3.51,0,0,1-3.5-3.32L128.42,36a3.5,3.5,0,0,1,3.5-3.69h13.15a3.51,3.51,0,0,1,3.51,3.33l.69,13.16a3.51,3.51,0,0,1-3.51,3.69",
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "131.96 41.04 137.7 46.49 145.44 38.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1510.32,251.3a41.45,41.45,0,1,1-41.45-41.44A41.44,41.44,0,0,1,1510.32,251.3Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1451.47,288.92c-25.11-37.79,0-75.23,0-75.23",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1486.18,213.68s25.12,37.45,0,75.24",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1465.17,211s-25.93,44.47,0,80.94",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1472.88,211s25.93,44.31,0,80.77",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1503.53,228.58c-29.94,21.5-70.26,1.5-70.26,1.5l-5.84,17.59s43.74,21.92,82.72,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1433.28,272.52s34.87,17.13,71.2,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1449.69,214.56s23.93,8.17,38.86,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1436.89,236.17q1.74.48,3.48.9c.31,2.88.68,5.76,1.13,8.65q2.51-3.65,4.82-7.37c.71.14,1.43.27,2.15.39q.84,4.24,1.89,8.49c1.42-2.52,2.77-5.06,4.07-7.62,1.19.15,2.38.27,3.57.38q-3.3,6.91-7.2,13.65l-2.56-.37c-.72-2.88-1.38-5.76-2-8.63q-2.38,3.72-5,7.37c-.84-.17-1.67-.36-2.5-.54q-1.27-7.66-1.92-15.3",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1458.45,240c1.18.11,2.37.19,3.55.26q1.21,4.17,2.64,8.31c1.21-2.68,2.34-5.39,3.41-8.1h2.18q1.59,4,3.36,8,1.42-4.09,2.64-8.22c1.2-.07,2.39-.15,3.58-.26q-2,7.4-4.65,14.71c-.86,0-1.71.07-2.57.09-1.22-2.7-2.38-5.42-3.46-8.14-1.12,2.72-2.3,5.44-3.56,8.14l-2.55-.09q-2.6-7.31-4.57-14.71",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1480.26,240c1.18-.11,2.37-.23,3.55-.37q1.93,3.87,4.07,7.7,1.08-4.29,1.93-8.58l2.16-.39q2.27,3.68,4.75,7.28c.44-2.85.83-5.71,1.15-8.56,1.17-.28,2.33-.58,3.49-.9q-.67,7.64-2,15.31c-.84.19-1.69.38-2.54.55-1.68-2.43-3.31-4.9-4.86-7.4-.62,2.89-1.31,5.78-2.07,8.65l-2.53.37q-3.86-6.74-7.12-13.66",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 1291.77,
    cy: 92.88,
    r: 42.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1291.77,92.88Q1289,72,1286.18,51.09a42.81,42.81,0,0,1,22,2.9,42,42,0,0,1,13.72,9.32,41.46,41.46,0,0,1,6.47,8.69Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1291.77,92.88l30.93-28.72A42.22,42.22,0,0,1,1333,83.82a43.13,43.13,0,0,1,.19,16.57A43.72,43.72,0,0,1,1330,110.7Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-32",
    cx: 511.78,
    cy: 69.15,
    r: 15.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 86.04,
    cy: 267.81,
    r: 12.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-34",
    cx: 1501.01,
    cy: 73.02,
    r: 17.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1167.17,267.53l-13.26-7.16-3,6.47a2.18,2.18,0,0,1-3.61.53l-24.76-27.93a2.18,2.18,0,0,1,1.57-3.63l38.13-1a2.18,2.18,0,0,1,2,3.09l-3.44,7.44,14.8,5.71a2.6,2.6,0,0,1,1.35,3.65l-6.31,11.75a2.6,2.6,0,0,1-3.52,1.06",
    transform: "translate(0 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsbusinessinsights6);
export default __webpack_public_path__ + "static/media/ANALYTICS & BUSINESS INSIGHTS 6.0851471659da6c9997eefb2d12ff5530.svg";
export { ForwardRef as ReactComponent };